<script>

import PerPageSelect from "@/components/ui/PerPageSelect.vue";

export default {
    components: {PerPageSelect},
    data() {
        return {
            error: '',
            loading: true,
            downloading: false,
            users: [],
            meta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            sort: {
                field: 'id',
                order: 'desc'
            },
            controller: null,
            perPage: parseInt(localStorage.getItem('perPage_trainers') || 10),
        }
    },
    methods: {
        loadData() {
            this.controller = new AbortController();
            this.loading = true;
            window.scrollTo({top: 0});
            axios.get('/users/trainers', {
                signal: this.controller.signal,
                params: {
                    page: this.meta.current_page,
                    per_page: this.perPage,
                    sort: this.sort.field,
                    order: this.sort.order
                }
            }).then(response => {
                this.users = response.data.data;
                this.meta.current_page = response.data.meta.current_page;
                this.meta.total = response.data.meta.total;
                this.meta.per_page = response.data.meta.per_page;
            }).catch(error => {
            }).finally(() => {
                this.loading = false;
            })
        },
        download() {
            this.downloading = true;
            let params = {
                sort: this.sort.field,
                order: this.sort.order,
                xlsx: 1
            }
            axios({
                url: '/users/trainers',
                method: 'GET',
                responseType: 'blob',
                params
            }).then((response) => {
                saveAs(response.data, 'trainers.xlsx');
            }).finally(() => {
                this.downloading = false;
            });
        },
        onPageChange(page) {
            this.controller.abort();
            this.meta.current_page = page;
            this.loadData();
        },
        onSort(field, order) {
            this.controller.abort();
            this.sort = {field, order};
            this.loadData();
        },
        onPerPageChange() {
            localStorage.setItem('perPage_trainers', String(this.perPage));
            this.meta.current_page = 1;
            this.loadData();
        },
    },
    mounted() {
        this.loadData();
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <div class="trainers-index users-index">

        <div class="buttons" v-if="$auth.isEmployer() || $auth.isAdmin()">
            <b-button type="is-link" @click="$router.push({name: 'trainers.create'})">
                {{ $t('trainers.labels.add_trainer') }}
            </b-button>
            <b-button v-if="$auth.isAdmin()" :loading="downloading" type="is-link" icon-left="download" @click="download">
                .xlsx
            </b-button>
        </div>

        <b-table
            :data="loading ? [] : users"
            :loading="loading"

            :paginated="!loading"
            backend-pagination
            :total="loading ? 0 : meta.total"
            :per-page="perPage"
            @page-change="onPageChange"
            :aria-next-label="$t('navigation.next_page')"
            :aria-previous-label="$t('navigation.previous_page')"
            :aria-page-label="$t('navigation.page')"
            :aria-current-label="$t('navigation.current_page')"

            backend-sorting
            sort-icon="arrow-up"
            default-sort-direction="asc"
            :default-sort="['company.name', 'asc']"
            @sort="onSort">

            <b-table-column field="email" :label="$t('users.fields.email.name')" sortable v-slot="props">
                {{ props.row.email }}
            </b-table-column>

            <b-table-column field="company.name" :label="$t('companies.fields.name.name')" sortable v-slot="props">
                {{ props.row.company.name }}
            </b-table-column>

            <b-table-column label="-" v-slot="props">
                <b-button type="is-link" size="is-small" icon-right="square-edit-outline"
                          @click="$router.push({name: 'trainers.edit', params: {id: props.row.id}})">
                </b-button>
            </b-table-column>

            <template #empty>
                <div v-if="!loading" class="block has-text-grey has-text-centered mb-4 mt-4">
                    {{ $t('trainers.labels.no_trainers') }}
                </div>
            </template>

            <template #bottom-left>
                <PerPageSelect v-model="perPage" @change="onPerPageChange" />
            </template>

        </b-table>

        <loader :loading="loading"></loader>
    </div>
</template>
